// OrphanedSchedules.tsx
import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Card, CardContent, CardHeader, Chip, IconButton, Typography } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import { useAuth } from "../../auth/AuthContext";
import {NRMetricsSchedules, optimizationIngestSchedulerApi} from "../../utils/optimizationIngestSchedulerUtil";
import {sx} from "../OptimizationIngestScheduler/styles";

export default function OrphanedSchedules() {
    const { getAccessToken } = useAuth();
    const [orphans, setOrphans] = useState<NRMetricsSchedules[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const token = await getAccessToken?.();
                const data = await optimizationIngestSchedulerApi.getOrphanedSchedules(token);  // New util method
                setOrphans(data);
            } catch (e: any) {
                setError(e.message || "Failed to load orphaned schedules");
            } finally {
                setLoading(false);
            }
        })();
    }, [getAccessToken]);

    const handleDelete = async (uuid: string, day: string) => {
        try {
            const token = await getAccessToken?.();
            if (!token) throw new Error("No auth token");

            await optimizationIngestSchedulerApi.deleteMetricScheduleDay(uuid, day, token);

            // Refetch the full list from backend
            const updatedOrphans = await optimizationIngestSchedulerApi.getOrphanedSchedules(token);
            setOrphans(updatedOrphans);

        } catch (e: any) {
            setError("Failed to delete: " + (e.message || "Unknown error"));
            console.error(e);
        }
    };

    return (
        <Box sx={{ m: 3 }}>
            <Card>
                <CardHeader title="Orphaned Schedules" subheader="Schedules tied to missing or inaccessible New Relic entities. Delete to free up your limit." />
                <CardContent>
                    {error && <Alert severity="error">{error}</Alert>}
                    {loading ? <Typography>Loading...</Typography> : (
                        orphans.length === 0 ? <Typography>No orphaned schedules found.</Typography> : (
                            orphans.map((sched) => (
                                <Box>
                                    <Typography>Entity: {sched.entityName || sched.entityGuid} (Missing)</Typography>
                                    <Box key={sched.uuid} sx={{ mb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                                        {sched.scheduleDays?.map(day => (
                                            <Chip
                                                key={day}
                                                label={`${day.toUpperCase()}: ${sched.enableTime}-${sched.disableTime}`}
                                                deleteIcon={<DeleteOutline />}
                                                onDelete={() => handleDelete(sched.uuid!, day)}
                                                sx={sx.buttonSx}
                                            />
                                        ))}
                                    </Box>
                                </Box>
                            ))
                        )
                    )}
                </CardContent>
            </Card>
        </Box>
    );
}